module.exports = __webpack_public_path__ + "img/31.538f9f99.png";